import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';

export enum GuaranteesUakdoControlFieldName {
  ExecutorMainDealConditionsStatus = 'executorMainDealConditionsStatus',
  UnfulfilledConditionsDetails = 'unfulfilledConditionsDetails',
  CoverageAccountPlacementStatus = 'coverageAccountPlacementStatus',
  DepositAccountPlacementStatus = 'depositAccountPlacementStatus',
}

export type TGuaranteesUakdoControlFormValues = {
  [GuaranteesUakdoControlFieldName.ExecutorMainDealConditionsStatus]: TAutocompleteOption | null;
  [GuaranteesUakdoControlFieldName.UnfulfilledConditionsDetails]: string;
  [GuaranteesUakdoControlFieldName.CoverageAccountPlacementStatus]: TAutocompleteOption | null;
  [GuaranteesUakdoControlFieldName.DepositAccountPlacementStatus]: TAutocompleteOption | null;
};
